/**
 * Video Cards lifetime-deal campaign.
 *
 * The deadline is a single fixed date shared by everyone rather than a per-user
 * rolling window, because the same deadline is quoted in the outbound email
 * sequence — a rolling per-user countdown would contradict the emails.
 *
 * To run a future campaign, bump CAMPAIGN_ID as well as the dates: the dismissal
 * flag is stored per campaign id, so reusing an id would leave the new banner
 * pre-dismissed for everyone who closed the old one.
 */
export const VIDEO_LTD_CAMPAIGN = {
	CAMPAIGN_ID: 'video-ltd-2026-07',

	/** ISO date the offer closes. Override per environment without a rebuild. */
	DEADLINE: process.env.REACT_APP_VIDEO_LTD_DEADLINE || '2026-08-06T23:59:59Z',

};

export const promoStorageKey = (campaignId: string) => `cc_promo_dismissed_${campaignId}`;

/** Whole days left until the deadline; 0 on the final day, negative once past. */
export const daysUntil = (deadlineIso: string, now: Date = new Date()): number => {
	const deadline = new Date(deadlineIso).getTime();
	if (Number.isNaN(deadline)) return -1;
	return Math.floor((deadline - now.getTime()) / (1000 * 60 * 60 * 24));
};
